//mypreset.ts
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const MyPreset = definePreset(
  Aura,
  {
    semantic: {
      primary: {
        50: '#f57424',
        100: '#f57424',
        200: '#f57424',
        300: '#f57424',
        400: '#f57424',
        500: '#f57424',
        600: '#f57424',
        700: '#f57424',
        800: '#f57424',
        900: '#f57424',
        950: '#f57424',
      },
    }
  }
);

export default MyPreset;